import React from 'react'
import Button from '../Button'

function CTACard({className, title, children, button, onClick}) {

  const STYLE_CARD={
    minWidth: "350px",
    maxWidth: "375px",
    minHeight: "165px",
    maxHeight:"250px"
  }
  return (
    <div className={`flex flex-col justify-between align-center m-6 ${className}`} style={STYLE_CARD}>
      <div className="mb-4">
        <h1 className="text-center font-medium text-primary text-xl mb-5 h-10">{title}</h1>
        {children && <div className="text-center text-gray-600">{children}</div>}
      </div>
      <div className="flex justify-center">
        {button && <Button className="" text={button} onClick={onClick}/>}
      </div> 
    </div>
      
  )
}
  
export default CTACard;
